export default __webpack_public_path__ + "static/paperless-awards-a78127313804d94adde67d4607d06854.png";